import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

const mockData = [
  {
    title: "Completed Applications",
    value: 10,
    label: "10 apps",
  },
  {
    title: "Pending Applications",
    value: 10,
    label: "10 apps",
  },
  {
    title: "Awaiting Decision",
    value: 10,
    label: "10 apps",
  },
  {
    title: "In Review",
    value: 10,
    label: "10 apps",
  },
];

const colors = ["success", "warning", "primary", "danger", "info"];

const BarDetailChart = ({
  value = 0,
  delta = 0,
  detlaLabel = "",
  data = mockData,
}) => {
  const deltaNum = parseInt(delta);

  return (
    <div>
      <div className="card custom-card">
        <div className="card-header justify-content-between">
          <div className="card-title">This month</div>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <h4 className="fw-bold mb-0">{value}</h4>
            <div className="ms-2">
              <span
                className={`badge  bg-${
                  deltaNum > 0 ? "success" : "danger"
                }-transparent`}
              >
                1.02
                <i
                  className={`ri-arrow-${
                    deltaNum > 0 ? "up" : "down"
                  }-s-fill align-middle ms-1`}
                >
                  {deltaNum}
                </i>
              </span>
              <span className="text-muted ms-1">{detlaLabel}</span>
            </div>
          </div>

          <ProgressBar>
            {data.slice(0, 5).map((item, x) => (
              <ProgressBar
                striped
                variant={colors[x]}
                now={item.value}
                key={x}
              />
            ))}
          </ProgressBar>

          <ul className="list-unstyled mb-0 pt-2 crm-deals-status">
            <li className="primary">
              <div className="d-flex align-items-center justify-content-between">
                <div>Completed Applications</div>
                <div className="fs-12 text-muted">987 apps</div>
              </div>
            </li>
            <li className="info">
              <div className="d-flex align-items-center justify-content-between">
                <div>Pending Applications</div>
                <div className="fs-12 text-muted">1,073 apps</div>
              </div>
            </li>
            <li className="warning">
              <div className="d-flex align-items-center justify-content-between">
                <div>Awaiting Decision</div>
                <div className="fs-12 text-muted">1,674 apps</div>
              </div>
            </li>
            <li className="success">
              <div className="d-flex align-items-center justify-content-between">
                <div>In Review</div>
                <div className="fs-12 text-muted">921 apps</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

BarDetailChart.propTypes = {};

export default BarDetailChart;
